import './styles.scss';

interface ModalTitleProps {
	text: string;
	alingment?: 'center' | 'left';
}
export const ModalTitle = ({ text, alingment }: ModalTitleProps) => <div className={`modalTitle modalTitle--${alingment}`}>{text}</div>;

export default ModalTitle;
